import * as React from 'react';

function Input(props) {
    const { type, className, disabled, onClick, onChange, accept, multiple, title, message, } = props;
    switch (type) {
        case "file":
            return (React.createElement(React.Fragment, null,
                React.createElement("input", { type: "file", accept: accept, multiple: multiple, onChange: onChange, onClick: onClick, className: className, disabled: disabled, style: {
                        border: "2px dashed #28a745",
                        borderRadius: "8px",
                        padding: "30px",
                        cursor: "pointer",
                        display: "block",
                        width: "100%",
                        marginBottom: "20px",
                    } }),
                title || message ? (React.createElement("p", { style: {
                        marginTop: "15px",
                        color: "#d9534f",
                        fontWeight: "bold",
                    } }, message || title)) : null));
        case "text":
        case "email":
        case "password":
        default:
            return (React.createElement(React.Fragment, null,
                React.createElement("input", { onChange: onChange, type: "text", style: {
                        border: "2px dashed #28a745",
                        borderRadius: "8px",
                        padding: "30px",
                        cursor: "pointer",
                        display: "block",
                        width: "100%",
                        marginBottom: "20px",
                    } }),
                title || message ? (React.createElement("p", { style: {
                        marginTop: "15px",
                        color: "#d9534f",
                        fontWeight: "bold",
                    } }, message || title)) : null));
    }
}

export { Input };
//# sourceMappingURL=index.js.map
